module.exports = __webpack_public_path__ + "static/media/clock-icon.7bc2cdbe.svg";